module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 81.ef00719e.png";